import Footer from "../../components/footer"
import Header from "../../components/header"
import SideBar from "../../components/sidebar"

const Terms = () => {
    return (<>
    <Header/>
    <SideBar/>
        <main class="main">

        <div class="site-breadcrumb" style={{background: 'url(assets/img/breadcrumb/01.jpg)'}}>
            <div class="container">
                <h2 class="breadcrumb-title">Terms Of Service</h2>
                <ul class="breadcrumb-menu">
                    <li><a href="index.html">Home</a></li>
                    <li class="active">Terms Of Service</li>
                </ul>
            </div>
        </div>


        <div class="py-120">
            <div class="container">
                <div class="row">
                    <div class="col">
                        <div class="terms-content">
                            <h3>Our Performance</h3>
                            <p>
                                Sed ac sollicitudin ipsum. Vivamus vulputate, enim sit amet aliquet lacinia, ex mauris
                                aliquam elit, vel pharetra augue arcu ultricies magna. Suspendisse justo erat, dignissim
                                ut imperdiet ut, convallis vitae urna. Vivamus tincidunt lacinia metus sed suscipit.
                                Phasellus luctus rhoncus mauris ut euismod. Aliquam elementum malesuada erat, vitae
                                bibendum ex rutrum eget. Mauris sed nunc mauris. Curabitur semper sed justo a
                                pellentesque. In hac habitasse platea dictumst. Mauris semper volutpat iaculis.
                                Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae;
                                Curabitur consectetur dignissim nulla id ornare. Praesent placerat dolor vitae tellus
                                lacinia, a malesuada est sodales. Praesent at consectetur sem, sed scelerisque arcu.
                                Maecenas malesuada lorem id sagittis scelerisque. In hac habitasse platea dictumst.
                            </p>
                        </div>
                        <div class="terms-content">
                            <h3>Cookie</h3>
                            <p>
                                Pellentesque sit amet nulla facilisis, lobortis ex at, consequat diam. Pellentesque sed
                                dui lorem. Aliquam vel euismod nunc. Nulla facilisi. Donec consectetur faucibus rutrum.
                                Pellentesque ac ultricies sapien, ac iaculis erat. Vivamus posuere eget nulla sit amet
                                vehicula. Donec finibus maximus eros, at tincidunt ipsum vestibulum ac. Integer vel
                                metus vehicula, consequat velit a, eleifend mi. Curabitur erat mauris, luctus non dictum
                                vel, fringilla dignissim quam. Phasellus eleifend porta fermentum. Pellentesque posuere
                                massa vitae odio pulvinar feugiat. Fusce a risus sodales, maximus sapien sit amet,
                                pharetra ipsum. Vivamus varius eros ac sapien pulvinar, nec tincidunt dui bibendum.
                                Proin consectetur nibh tortor, nec vulputate ex posuere eget.
                            </p>
                        </div>
                        <div class="terms-content">
                            <h3>Payments</h3>
                            <p>
                                Amet nulla facilisis, lobortis ex at, consequat diam. Pellentesque sed dui lorem.
                                Aliquam vel euismod nunc. Nulla facilisi. Donec consectetur faucibus rutrum.
                                Pellentesque ac ultricies sapien, ac iaculis erat. Vivamus posuere eget nulla sit amet
                                vehicula. Donec finibus maximus eros, at tincidunt ipsum vestibulum ac. Integer vel
                                metus vehicula, consequat velit a, eleifend mi. Curabitur erat mauris, luctus non dictum
                                vel, fringilla dignissim quam. Phasellus eleifend porta fermentum. Pellentesque posuere
                                massa vitae odio pulvinar feugiat. Fusce a risus sodales, maximus sapien sit amet,
                                pharetra ipsum. Vivamus varius eros ac sapien pulvinar, nec tincidunt dui bibendum.
                                Proin consectetur nibh tortor, nec vulputate ex posuere eget.
                            </p>
                        </div>
                        <div class="terms-content">
                            <h3>Refund Policy</h3>
                            <p>
                                Donec ut vestibulum sem, in faucibus mauris. Nulla et luctus nulla. Vestibulum
                                consectetur nisi nec lobortis pretium. Fusce dignissim in sem in bibendum. Vivamus
                                fermentum massa et egestas gravida. Suspendisse at vulputate ante, id tempus nunc.
                                Curabitur sed dolor a elit ornare commodo. Curabitur blandit enim nulla, ornare suscipit
                                risus pretium ut. Nullam rhoncus, sem eget dapibus elementum, purus dolor rutrum magna,
                                nec laoreet odio sapien sit amet erat.
                            </p>
                            <p>
                                Proin non ante purus. Donec ante enim, semper vel mauris at, rutrum blandit mauris.
                                Vivamus at ante sit amet leo consequat viverra quis at odio. Proin arcu magna, placerat
                                sed lorem id, rutrum convallis ante.
                            </p>
                            <p>
                                Nam venenatis vestibulum mauris ut viverra. Ut porta consequat lorem a ullamcorper. In
                                et arcu quam. Nunc tristique justo nec lectus ornare placerat. Nulla ut fringilla mi.
                                Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae.
                            </p>
                        </div>
                        <div class="terms-content">
                            <h3>Hyperlinking to our Content</h3>
                            <p>Sed ac sollicitudin ipsum ivamus vulputate enim sit amet aliquet lacinia mauris aliquam
                                elit:</p>
                            <ul class="terms-list ms-4">
                                <li>1. Ut scelerisque hendrerit venenatis</li>
                                <li>2. Proin fermentum lacus nec augue blandit placerat</li>
                                <li>3. Ut vestibulum elit justo suscipit sem ultricies</li>
                                <li>4. Integer fermentum vitae magna in condimentum</li>
                                <li>5. Aenean ultrices neque id pellentesque tincidunt</li>
                                <li>6. Donec ut vestibulum sem, in faucibus mauris.</li>
                            </ul>
                        </div>
                        <div class="terms-content">
                            <h3>Disclaimer</h3>
                            <p>
                                Donec facilisis consequat nisi. Vivamus euismod at ipsum a gravida. Quisque vitae augue
                                maximus elit iaculis tincidunt. Quisque dapibus dui non justo iaculis volutpat.
                                Phasellus vulputate tempus lorem vitae vehicula. Maecenas interdum venenatis ante,
                                scelerisque porta nibh mollis vitae. Curabitur in erat porttitor, imperdiet lectus non,
                                porttitor odio. Donec efficitur efficitur dapibus. Aenean sit amet tortor id lorem
                                ultricies rhoncus. Etiam ornare eros eu commodo vehicula. Curabitur vel enim eget velit
                                tincidunt viverra eu in risus. Aliquam suscipit tellus eu fermentum facilisis.
                                Pellentesque volutpat posuere ligula. Fusce et consequat mi.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </main>
    <Footer/>
    </>
    )
}
export default Terms